import Vue from 'vue'

export default {
  getProjectActions ({ commit }, name) {
    return Vue.api.get('engine/actions/' + (name || ''))
      .then((res) => res.data)
  }
}
